/**
 * SG Peppol IRSP Submission Status Constants
 */

// Overall submission status
export const sgPeppolStatusOverall = [
  { key: 'Submitted', label: 'Submitted' },
  { key: 'Processing', label: 'Processing' },
  { key: 'PartiallyCompleted', label: 'Partially Completed' },
  { key: 'Completed', label: 'Completed' },
  { key: 'Held', label: 'Held for review' },
  { key: 'Error', label: 'Error' },
  { key: 'Rejected', label: 'Rejected' },
]

// Status color mapping
export const statusColors = {
  Submitted: 'primary',
  Processing: 'primary',
  PartiallyCompleted: 'warning',
  Completed: 'success',
  // Held by the AI confidence gate — awaiting tenant review (not an error).
  Held: 'warning',
  Error: 'danger',
  Rejected: 'danger',
}

// API status (Peppol/IRAS)
export const apiStatusLabels = {
  SUCC: '✓ Sent',
  RJCT: '✗ Failed',
  PEND: '⏳ Pending',
}

// Route/Destination labels
export const routeLabels = {
  C3C5: 'Peppol + IRAS',
  C5: 'IRAS Only',
}

// Document type labels. Numeric codes are UBL invoice type codes; the named
// values are the BIS Ordering / response document types so sent OrderResponse /
// InvoiceResponse submissions render clearly in the list and detail views.
export const documentTypeLabels = {
  '380': 'Invoice',
  '381': 'Credit Note',
  '383': 'Debit Note',
  Invoice: 'Invoice',
  CreditNote: 'Credit Note',
  DebitNote: 'Debit Note',
  Order: 'Order',
  OrderChange: 'Order Change',
  OrderCancellation: 'Order Cancellation',
  OrderResponse: 'Order Response',
  OrderAgreement: 'Order Agreement',
  InvoiceResponse: 'Invoice Response',
}

// History source labels
export const historySourceLabels = {
  SUBMISSION: 'Submission',
  CALLBACK: 'Callback',
  STATUS_CHECK: 'Status Check',
}

// Common error codes and resolutions
export const errorResolutions = {
  'IRASC5-023': {
    message: 'Seller GST identifier MUST be provided for taxable supplies',
    resolution: 'Add GST Registration Number to tenant settings via Settings → SG Peppol Configuration',
  },
  'IRASC5-007': {
    message: 'Invoice MUST have an Invoice number',
    resolution: 'Check that the document number is populated correctly',
  },
  'IRASC5-024': {
    message: 'Tax scheme identifier MUST be \'GST\'',
    resolution: 'Check tax code mapping in the document',
  },
  'ER-90400': {
    message: 'Schematron validation error',
    resolution: 'Review full error details for specific validation issues',
  },
}
